import React from "react";
import NumberFormat from "react-number-format";

interface YearMonthNumberFormatProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  [key: string]: any;
}

const YearMonthNumberFormat = ({
  inputRef,
  onChange,
  name,
  ...rest
}: YearMonthNumberFormatProps) => (
  <NumberFormat
    {...rest}
    getInputRef={inputRef}
    format="####/##"
    mask="_"
    isAllowed={({ value }: any) => {
      const month = value.slice(4, 6);
      if (month.length < 2) return true;
      return Number(month) >= 1 && Number(month) <= 12;
    }}
    onValueChange={(values: any) => {
      onChange({ target: { name, value: values.formattedValue } });
    }}
    name={name}
  />
);

export default YearMonthNumberFormat;
